export const totalByClient = {
	label: "Total por cliente",
	title: "Total de ventas por cliente",
	table: {
		title: "Consumo de mesas",
		columns: {
			name: "NOMBRE",
			document: "RFC",
			openedAt: "APERTURA",
			closedAt: "CIERRE",
			payment: "PAGO",
			serviceValue: "VALOR DEL SERVICIO",
			discount: "DESCUENTOS",
			refundValue: "REEMBOLSOS",
			totalValue: "TOTAL",
			products: {
				imageUrl: "FOTO",
				sku: "SKU",
				name: "NOMBRE DEL PRODUCTO",
				tableName: "MESA",
				payment: "PAGO",
				quantity: "CANTIDAD",
				unitValue: "VALOR UNITARIO",
				totalValue: "VALOR TOTAL",
			},
		},
	},
};
